import type { ComponentType } from 'react';

// Maps a default-exporting page module to the shape React Router's `lazy` expects.
export const asRoute = (m: { default: ComponentType }) => ({ Component: m.default });
